export default "__VITE_ASSET__f2e8adb5__"